import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { WorkbookCompare } from './components/WorkbookCompare';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostSection } from './components/CostSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-ink font-sans antialiased" data-id="element-0" data-mp="31bi8bik7icdb">
      <Hero data-id="element-1" data-mp="2wk9xqj754kyk" />
      <main data-id="element-2" data-mp="2wjqgl4pbe0ll">
        <PainSection data-id="element-3" data-mp="2wiyv4mpflj91" />
        <TomosSection data-id="element-4" data-mp="2wip54z4dzc3c" />
        <BonosSection data-id="element-5" data-mp="2wi5qbra193tj" />
        <PricingSection id="precios" eyebrow="Precio de lanzamiento — cierra en" heading="Elegí tu combo" data-id="element-6" data-mp="28tw5arkn8k3g" />
        <WorkbookCompare data-id="element-7" data-mp="23v2rey1g2r2r" />
        <Testimonials data-id="element-8" data-mp="23ti5txx3yih1" />
        <Guarantee data-id="element-9" data-mp="3ikh829m9asyz" />
        <Faq data-id="element-10" data-mp="3iiwfgpji5k3r" />
        <CostSection data-id="element-11" data-mp="3ijfx0558q6h9" />
        <PricingSection id="cierre" eyebrow="Últimas horas al precio de lanzamiento" heading="Empezá hoy tu Reset Integral" data-id="element-12" data-mp="3ihv0i9zd8dgr" />
      </main>
      <Footer data-id="element-13" data-mp="3rcsyhvhdegey" />
    </div>;
}